export default __webpack_public_path__ + "static/media/vector.cc2b323c.svg";